import { useMemo } from 'react';
import { AnimatePresence, motion } from 'motion/react';

import { useGetParams } from './hooks/useGetParams';
import { useVote } from './hooks/useVote';

import AdvtFullSize from './components/AdvtFullSize/AdvtFullSize';
import { Player } from './components/Player/Player';
import { LogoVideo } from './components/LogoVideo/LogoVideo';
import { AdvtVideo } from './components/AdvtVideo/AdvtVideo';

import defaultBackground from './assets/images/bg.png';
import { loadImages } from './helpers/titreHelper';

function App() {
  const { voteState, currentState, isVisible } = useVote();

  const { bg } = useGetParams();

  const background = useMemo(() => {
    return bg && bg !== '0'
      ? `url(${bg === '1' ? defaultBackground : bg}) center/cover no-repeat`
      : `none`;
  }, [bg]);

  const player = useMemo(() => {
    if (!voteState) {
      return null;
    }

    const varMaxCount = voteState.vars?.reduce((max, current) => {
      return parseInt(current.count) > parseInt(max.count) ? current : max;
    });

    if (varMaxCount?.varImgUrl) {
      loadImages([varMaxCount.varImgUrl]);
    }

    return varMaxCount;
  }, [voteState]);

  return (
    <div className="app-wrapper" style={{ background }}>
      <AnimatePresence mode="wait">
        {currentState === 'S1' && (
          <motion.div
            key={`${currentState}-AdvtVideo`}
            className="motionBlock"
            exit={{ opacity: 0 }}
            transition={{ duration: 0.5 }}
          >
            <AdvtVideo />
          </motion.div>
        )}
        {currentState === 'S2' && (
          <motion.div
            className="motionBlock"
            key={`${currentState}-AdvtFullSize`}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.5 }}
          >
            <AdvtFullSize />
          </motion.div>
        )}
        {currentState === 'S3' && (
          <motion.div className="motionBlock">
            <Player player={player} />
          </motion.div>
        )}

        {currentState === 'S4' && (
          <motion.div
            className="motionBlock"
            key={`${currentState}-LogoVideo`}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.5 }}
          >
            <LogoVideo voteState={voteState} />
          </motion.div>
        )}
      </AnimatePresence>

      <div id="img-loader"></div>
    </div>
  );
}

export default App;
